import { render, staticRenderFns } from "./PasswordResetPerform.vue?vue&type=template&id=0c4a7e8a&scoped=true"
import script from "./PasswordResetPerform.vue?vue&type=script&lang=js"
export * from "./PasswordResetPerform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.2__lodash@4_9acdcff83b5891d2d7c120609da332e7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a7e8a",
  null
  
)

export default component.exports